<template>
	<div>
		<div class="row mb-3 px-3">
			<div class="bntGroup">
				<base-button v-if="typeof this.$route.query.client_id !='undefined'" type="primary" simple @click="GoToClient()" class="mr-2"><i class="tim-icons icon-double-left mr-2"></i>К клиенту</base-button>
				<base-button v-if="typeof this.objGetParams.taskend_id != 'undefined'" type="primary" simple @click="showPresentation()" class="mr-2"><i class="tim-icons icon-book-bookmark mr-2"></i>{{strPrezBtnCaption}}<!--span class="ml-2">+10</span--></base-button>
			</div>
		</div>
		<ssoModuleScndFilter v-if="bIsObjects" @change="OnFilterApply"/> 
		<h6 class="mb-3 text-right">Объектов найдено: {{this.masObjects_total}}</h6>

		<ReClientNeeds />

		<template v-if="bIsObjects">
			<ReSearchScndObjects :masObjects="ApiData" v-model="dSearchType" @change="OnFilterApply()" />
		</template>

		<template v-else>
			<RePresentation :masPresentationObjects="masPresentationObjects.flat_arr" :tabChange="validateStep">
				<template v-slot:step1>
					<step1SecondObj
						ref="step1"
						@on-validated="onStepValidated"
						:masPresentationObjects="masPresentationObjects.flat_arr"
						@change="setForUpdate()"
					/>				
				</template>
				<template v-slot:step2>
					<StpsndOpts
						ref="step2"
						@on-validated="onStepValidated"
						v-model="masViewOpts"
					/>				
				</template>
				<template v-slot:step3>
					<StptrdSendNew
						ref="step3"
						@on-validated="onStepValidated"
						@sendpres="sendPress"
						:masContacts="masClient[0].contacts"
						:linkText="linkText"
					/>
				</template>
			</RePresentation>
		</template>

		<Pagination v-if="bIsObjects && (/*typeof $GVO.GetAllGet().dSearchType != 'undefined' &&*/ $GVO.GetAllGet().dSearchType!='flatmap')" 
			:class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
			:type="'info'" 
			:total="parseInt(masObjects_total)" 
			:perPage="parseInt(10)"
			:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
			:pClick="pClick">
		</Pagination>
	</div>
</template>

<script>
	import ReSearchScndObjects from 'src/our_modules/SearchSendObjects/ReSearchScndObjects.vue';
	import RePresentation from 'src/our_modules/SearchSendObjects/RePresentation.vue';
	import ssoModuleScndFilter from 'src/our_modules/SearchSendObjects/sso_module_scnd_filter.vue';
	import Pagination from 'src/our_components/RePagination';
	import ReClientNeeds from 'src/our_modules/SearchSendObjects/ReClientNeeds.vue';

	import step1SecondObj from 'src/our_modules/SearchSendObjects/PresentationWizard/step1SecondObj.vue';
	import StpsndOpts from 'src/our_modules/SearchSendObjects/PresentationWizard/StpsndOpts.vue';
	import StptrdSendNew from 'src/our_modules/SearchSendObjects/PresentationWizard/StptrdSendNew.vue';


	export default {
		name: 'ssosecondbuildings',
		components: {
			ReSearchScndObjects,
			ssoModuleScndFilter,
			Pagination,
			ReClientNeeds,
			RePresentation,

			step1SecondObj,
			StpsndOpts,
			StptrdSendNew
			

		},
		props: {
			counter: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				bIsObjects:true,
				presUpdated:false,
				ApiData: [],
				dSearchType: 'flats',
				masObjects_total: 0,
				count2page: 12,
				objGetParams:{},
				linkText: '',
				masPresentationObjects: {},
				wizardModel: {},
				masViewOpts:[

					{
						elementGetParamMap: 'image',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Фото',
						label_on: 'Да',
						label_off: 'Нет',
					},				
					{
						elementGetParamMap: 'description',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Описание',
						label_on: 'Да',
						label_off: 'Нет',
					},

					{
						elementGetParamMap: 'price',
						elementType: 'switcher',
						element_model: true,
						element_model_default: true,
						placeholder: 'Цена объекта',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'staff',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Ответственные за ячейки',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'phone',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Телефон собственника/агента',
						label_on: 'Да',
						label_off: 'Нет',
					},
					{
						elementGetParamMap: 'auto_add_new_build',
						elementType: 'switcher',
						element_model: false,
						element_model_default: false,
						placeholder: 'Автоматически подобрать объекты первичного рынка',
						label_on: 'Да',
						label_off: 'Нет',
					},					
				],
				masClient: [{contacts:[]}],

			}
		},
		watch: {
			'$route' (to, from) {
				//console.log(to);
				//console.log(from);
				this.getApiData(); // перенёс из OnFilterApply
			}
		},
		computed: {
			strPrezBtnCaption(){
				if(this.bIsObjects)return 'Моя презентация';
				else return 'В поиск';
			}
		},
		methods: {
			setForUpdate(){
				this.presUpdated = true;
			},
			makeViewObj(){
				let objRet = {};
				for (let i = 0; i < this.masViewOpts.length; i++) {
					objRet[this.masViewOpts[i].elementGetParamMap] = this.masViewOpts[i].element_model;
				}
				// console.log(objRet);
				return objRet;
			},			
			onStepValidated(validated, model) {
				this.wizardModel = { ...this.wizardModel, ...model };
			},				
			validateStep(ref) {
				if(ref == 'step2') this.printPress(); // формируем презентацию
				if(ref == 'step3') this.wizardComplete();
				return this.$refs[ref].validate();
			},
			sendPress(objSend) {
				/*
				this.bIsSendSection = !this.bIsSendSection;
				this.bIsSend = true;
				*/
				if(objSend.strAddr != '' && objSend.strNote != ''){
					this.$GVO.ApiCall('SEND_PRESENTATION',{obj:'presentations',flt:{'path':this.linkText,'cont_type':'mail','cont_value':objSend.strAddr,'mess_text':objSend.strNote}})
					.then((objApi) => {
						if(objApi.success === true){
							//this.linkText = objApi.data.link;
							this.$GVO.showAlert('Презентация','Презентация отправлена','btn btn-success btn-fill');
						}
					}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
				}else{
					alert('адрес или текст сообщения пусто');
				}
			},			
			printPress(){
				let objItogGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('CREATE_PRESENTATION',{obj:'presentations',flt:{'task_id':objItogGetParams.task_id,'taskend_id':objItogGetParams.taskend_id,'client_id':objItogGetParams.client_id}, iData:{...this.makeViewObj()}})
				.then((objApi) => {
					if(objApi.success === true){
						this.linkText = objApi.data.link;
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			},
			wizardComplete() {
				//console.log('В визарде нажали финиш');
				const objGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('RUN_TASK',{obj:'services' ,flt:{'client_id':objGetParams.client_id,'id':objGetParams.task_id,'taskend_id':objGetParams.taskend_id}})
				.then((objApi) => { 
					if(objApi.success === true){
						location.href = '/data/clients/id/'+objGetParams.client_id;
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
			},

			getClient(){
				const objGetParams = this.$GVO.GetAllGet();
				if(typeof objGetParams.client_id != 'undefined'){
					this.$GVO.ApiCall('GET',{obj:'client' ,flt:{id:objGetParams.client_id}})
					.then((objApi) => { 
						this.bIsLoading = false;
						//console.log(objApi);
						if(objApi.success === true){
							if(typeof this.$GVO.cats['CONTACTS_TYPES'] == 'undefined'){
								this.$GVO.ApiCall('GET_CONTACTS_TYPES',{obj:"staff"})
									.then((objApiCat) => { 
										//console.log('GET_CONTACTS_TYPES',objApi);
										if(objApiCat.success === true){
											this.$GVO.cats['CONTACTS_TYPES'] = objApiCat.data;
											this.masClient = objApi.data;
										}
									}).catch(errorObjApi => {console.error(errorObjApi);});
							}else{
								this.masClient = objApi.data;
							}
						}
					}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
				}
			},

			getApiData(){
				this.ApiData = [];
				this.presUpdated = false;
				let filter = {};
				
				this.objGetParams = this.$GVO.GetAllGet();
				// console.log('getApiData this.objGetParams после GetAllGet',this.objGetParams);
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
					filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
					// console.log('filter2',filter);	
				}
				filter.act=1;
				this.$GVO.ApiCall('GET',{obj:'SecondObj',flt:{...filter}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
							// this.masObjects_total=objApi.countpage;
							
						}else{
							this.ApiData = [];	
						}
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}else{
						this.ApiData = [];
						this.masObjects_total=0;
					}
				}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
			},
			OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
				// console.log(strItogGetParams);
				if(strItogGetParams == undefined){
					let objItogGetParams = this.$GVO.GetAllGet();
					// console.log('OnFilterApply',strItogGetParams);
					if(typeof objItogGetParams.dSearchType !='undefined') {
						if(['flats','flatmap'].indexOf(objItogGetParams.dSearchType)==-1)objItogGetParams.dSearchType = 'flats';
					}
					if(typeof objItogGetParams.dSearchType !='undefined' && this.dSearchType != objItogGetParams.dSearchType) {
						objItogGetParams.dSearchType = this.dSearchType;
						if(typeof objItogGetParams['p'] != 'undefined'){
							delete objItogGetParams['p'];
						}
					}
					strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
				}
				
				this.$router.push({path: location.pathname+'?'+strItogGetParams});
				// this.getApiData();
			},
			pClick(e){
				let strItogGetParams = '';
				let objItogGetParams = this.$GVO.GetAllGet();
				objItogGetParams.p=parseInt(e);
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
				this.OnFilterApply(strItogGetParams);
			},
			showPresentation() {
				this.bIsObjects = !this.bIsObjects;	
				if(!this.bIsObjects){
					this.getPresentations();
				}	
				if(this.presUpdated){
					// console.log(this.presUpdated);
					this.getApiData();
				}	
			},
			getPresentations(){
				let objItogGetParams = this.$GVO.GetAllGet();
				this.$GVO.ApiCall('GET',{obj:'presentations',flt:{task_id:objItogGetParams.task_id,taskend_id:objItogGetParams.taskend_id,client_id:objItogGetParams.client_id}})
				.then((objApi) => {
					if(objApi.success === true){
						this.masPresentationObjects = objApi.data;
					}
				}).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
			},
			GoToClient(){
				if(typeof this.$route.query.client_id != 'undefined'){
					location.href='/data/clients/id/'+this.$route.query.client_id;
				}
			},			

		},
		mounted() {
			var queryParams = new URLSearchParams(window.location.search);
			//queryParams.set("dSearchType", "flats");
			history.replaceState(null, null, "?"+queryParams.toString());
			this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.objGetParams.show_pres != 'undefined') this.showPresentation();
			this.getApiData();
		}
	}
</script>
